import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {AuthModule} from "./auth/auth.module";
import {LoginComponent} from "./auth/login/login.component";
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {JwtInterceptor} from "./services/jwt.interceptor";
import {OuvrageComponent} from './ouvrage/ouvrage.component';
import {ApolloModule} from "apollo-angular";
import {GraphQLModule} from './graphql.module';
import {PrimeNgModule} from "./prime-ng/prime-ng.module";
import {CommonModule} from "@angular/common";
import {CreateOuvrageComponent} from './ouvrage/create-ouvrage/create-ouvrage.component';
import {BulkCreateOuvrageComponent} from './ouvrage/bulk-create-ouvrage/bulk-create-ouvrage.component';
import {EditableFieldComponent} from "./commons/fields/editable-field/editable-field.component";
import {DisplayFieldComponent} from "./commons/fields/display-field/display-field.component";
import {FiltersComponent} from "./commons/filters/filters.component";
import {OuvrageModule} from "./ouvrage/ouvrage.module";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {ListOuvrageComponent} from "./ouvrage/list-ouvrage/list-ouvrage.component";
import {DashboardRessourcesNumeriquesComponent} from './ressources_numeriques/dashboard-ressources-numeriques/dashboard-ressources-numeriques.component';
import {DispatchMaxComponent} from './ressources_numeriques/dispatch-max/dispatch-max.component';
import {HotTableModule} from "@handsontable/angular";
import {registerAllModules} from "handsontable/registry";
import {RessourcesNumeriquesModule} from "./ressources_numeriques/ressources-numeriques.module";
import {PagesAtterissageComponent} from "./ressources_numeriques/pages-atterissage/pages-atterissage.component";
import {HandsontableComponent} from "./handsontable/handsontable.component";
import {ResumeOuvrageComponent} from "./ouvrage/resume-ouvrage/resume-ouvrage.component";
import {RessourcesNumeriquesComponent} from "./ressources_numeriques/ressources-numeriques/ressources-numeriques.component";
import {registerCellType} from "handsontable/cellTypes/registry";
import {KeyValueListEditor} from "./handsontable/cellType/keyValueDropdown";
import {RessourcesNumeriquesListComponent} from "./ressources_numeriques/ressources-numeriques-list/ressources-numeriques-list.component";
import {MiniliensComponent} from './miniliens/miniliens.component';
import {OgrnPlayListComponent} from './ogrn_play/ogrn-play-list/ogrn-play-list.component';
import {TreeModule} from "primeng/tree";
import {UsersListComponent} from './users/users-list/users-list.component';
import {NgxDocViewerModule} from "ngx-doc-viewer";
import {StepsModule} from "primeng/steps";
import {AuthInterceptor} from "./services/auth.interceptor";
import {InputNumberModule} from "primeng/inputnumber";
import {environment} from "../environments/environment";
//SSO MODULES
import {MSAL_INSTANCE, MsalModule, MsalRedirectComponent, MsalService} from "@azure/msal-angular";
import { BrowserCacheLocation, IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';

registerAllModules();
registerCellType(KeyValueListEditor)

export function MSALInstanceFactory(): IPublicClientApplication{
  return new PublicClientApplication({
    auth:{
      clientId: environment.clientId,
      authority: environment.authority,
      redirectUri: environment.redirectUri,
      navigateToLoginRequestUrl: true,
    },
    cache:{
      cacheLocation: BrowserCacheLocation.LocalStorage,
    },

  })
}

@NgModule({
  declarations: [
    AppComponent,
    EditableFieldComponent,
    DisplayFieldComponent,
    CreateOuvrageComponent,
    BulkCreateOuvrageComponent,
    ListOuvrageComponent,
    FiltersComponent,
    DashboardRessourcesNumeriquesComponent,
    DispatchMaxComponent,
    PagesAtterissageComponent,
    HandsontableComponent,
    ResumeOuvrageComponent,
    RessourcesNumeriquesComponent,
    RessourcesNumeriquesListComponent,
    MiniliensComponent,
    OgrnPlayListComponent,
    UsersListComponent,
  ],
    imports: [
        CommonModule,
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        AuthModule,
        ApolloModule,
        HttpClientModule,
        GraphQLModule,
        PrimeNgModule,
        OuvrageModule,
        BrowserAnimationsModule,
        HotTableModule,
        RessourcesNumeriquesModule,
        TreeModule,
        NgxDocViewerModule,
        StepsModule,
        InputNumberModule,
        //SSO MODULES
        MsalModule,
    ],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true},
    {provide: MSAL_INSTANCE, useFactory: MSALInstanceFactory}, 
    MsalService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
